import { useRef } from "react";
import { hasDepsChanged } from "../utils/has-deps-changed";
export var useStableMemo = function useStableMemo(cb, deps) {
  var curDeps = useRef();
  var curVal = useRef();
  if (!curVal.current || hasDepsChanged(deps, curDeps.current)) {
    curVal.current = cb();
    curDeps.current = deps;
  }
  return curVal.current;
};